<div class="ttmodal" *ngIf="!isInspectionEdit">
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{ isEditing ? "Editing Observation List" : "Adding Observation List" | translate | async }}<!--  {{ title }} -->
    </span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
  <div class="ttmodal__body">

    <div>
        <mat-form-field class="input">
          <input class="titleInput" matInput placeholder="{{'Title' | translate | async}}" type="text" [(ngModel)]="Title" 
          required>
        </mat-form-field>
    </div>

    <div>
      <mat-form-field class="input">
        <mat-select placeholder="Inspection Type" [(ngModel)]="InspectionTypeId"  required>
              <mat-option  [value]="0" > All </mat-option>
              <mat-option  [value]="1" > Pre-shipment Inspection </mat-option>
              <mat-option  [value]="7" > Ready to Ship Inspection </mat-option>
              <mat-option  [value]="3" > Arrival Repairer Inspection </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="input">
        <mat-select placeholder="Status" [(ngModel)]="Active"  required>
          <mat-option [value]="false"> {{ 'Disable' | translate | async }}  </mat-option>
          <mat-option [value]="true">  {{ 'Enable' | translate | async }}  </mat-option>
        </mat-select>
      </mat-form-field>
    </div>


  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()"> {{ 'Cancel' | translate | async }}</button>
    <button mat-raised-button color="warn"   (click)="ValidationCheck()"><span class="button__text">{{ 'Save Observation List' | translate | async }} </span></button>
  </div>
</div>

<div class="ttmodal" *ngIf="isInspectionEdit">
  <div class="ttmodal__header">
    <span class="ttmodal__title">
      {{ isEditing ? "Editing Observation List" : "Adding Observation List" | translate | async }}<!--  {{ title }} -->
    </span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
  <div class="ttmodal__body">

    <div>
        <mat-form-field class="input">
          <input class="titleInput" matInput placeholder="{{'Title' | translate | async}}" type="text" [(ngModel)]="Title" 
          required>
        </mat-form-field>
    </div>

  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()"> {{ 'Cancel' | translate | async }}</button>
    <button mat-raised-button color="warn"   (click)="InspectionSaveObservation()"><span class="button__text">{{ 'Save Observation List' | translate | async }} </span></button>
  </div>
</div>